import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { UtilService } from '@services';
import { ServiceRequest } from 'src/app/models/service-request';

@Component({
  selector: 'app-service-requests-table',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatTableModule],
  templateUrl: './service-requests-table.component.html',
  styleUrl: './service-requests-table.component.scss',
})
export class ServiceRequestsTableComponent {
  @Input() serviceRequests: ServiceRequest[] = [];
  columns: string[] = [
    'customer',
    'orderNumber',
    'pickupAddress',
    'deliveryAddress',
    'otp',
    'weight',
    'volume',
    'packageCount',
    'createdAt',
    'updatedAt',
    'status',
  ];

  constructor(private router: Router, public utils: UtilService) {}

  public navToServiceRequestDetails(serviceRequestId: string): void {
    this.router.navigate(['/service-requests', serviceRequestId]);
  }
}
